module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-input-tag-wrapper",
    class: {
      'read-only': _vm.readOnly
    },
    on: {
      "click": function($event) {
        _vm.focusNewTag()
      }
    }
  }, [_vm._l((_vm.tags), function(tag, index) {
    return _c('span', {
      staticClass: "input-tag"
    }, [_c('span', [_vm._v(_vm._s(tag))]), _vm._v(" "), (!_vm.readOnly) ? _c('a', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.remove(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (!_vm.readOnly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    staticClass: "new-tag",
    attrs: {
      "placeholder": _vm.getPlaceholder(),
      "type": "text"
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        $event.stopPropagation();
        _vm.removeLastTag()
      }, function($event) {
        if (!('button' in $event) && $event.keyCode !== 188 && _vm._k($event.keyCode, "enter", 13) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        _vm.addNew(_vm.newTag)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-613a901a"}!./src/app/components/form-input-contacts/form-input-contacts.html
// module id = 484
// module chunks = 1